import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import { routeMap } from "./Routes/routeMap";
import PrivateRoute from "./Routes/PrivateRoute";
import AuthRoute from "./Routes/AuthRoute";

const AppWrapper = () => {
  return (
    // <OuterContainer>
    //   <MainContainer>
        <Routes>
          {routeMap.map(({ private: isPrivate, separate: isSeparate, requiredPermission ,...props }) => (
            <Route key={props.path} path={props.path} element={isSeparate ? props.element : isPrivate ? <PrivateRoute requiredPermission={requiredPermission} element={props.element} /> : <AuthRoute element={props.element} />} />
          ))}
        </Routes>
      // </MainContainer>
      // {/* <Footer /> */}
    // </OuterContainer>
  );
};

export default AppWrapper;
